module.exports = __webpack_public_path__ + "img/paypal.f495ac5.svg";